import React, { Component } from 'react';
import { submit } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';

import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import {
  StyledHeader,
  StyledMain,
  StyledHeaderContainer,
  StyledAddButton,
  StyledTableContainer,
} from 'helpers/StyledTableComponentsHelper';

import * as prospectsActions from 'actions/prospectsActions';
import { getLandlordTrafficSources } from 'actions/landlordLeadsActions';

import { getProperties } from 'actions/landlordPropertiesActions';

import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';

import { AccentColor } from 'helpers/AccentColorHelper';
import { drawerStyle } from 'helpers/tableHelpers';

import withMobileDialog from '@material-ui/core/withMobileDialog';

import { MuiThemeProvider } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';

import Drawer from 'components/ui/Drawer';
import CreateProspectDrawerWizard from './CreateProspectDrawerWizard';

import ProspectDetails from './ProspectDetails';
import TabbedTable from 'components/ui/TabbedTable';
import MobileTable from 'components/ui/MobileTable';
import TableFilters from 'components/ui/TableFilters';
import { timeFromNow, formatPhone } from 'helpers/Formatter';
import StatusTag from 'components/ui/StatusTag';
import { deepDiver } from 'helpers/utilities';
import { featureEnabled } from 'helpers/ToggleBot';

import styled from 'styled-components';

const StyledQualitySpan = styled.span`
  color: var(--yuhu-red);
  font-family: 'Circular-Bold';
  text-transform: capitalize;

  ${({ temperature }) =>
    temperature === 'cold' &&
    `
    color: var(--cool-green);
  `} ${({ temperature }) =>
      temperature === 'warm' &&
      `
    color: var(--warm-purple);
  `};
`;

const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: '100vh',
    height: 430,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    backgroundColor: 'white',
    minWidth: 0,
    overflow: 'auto',
  },
  paper: {
    boxShadow: 'none !important',
  },
  toolbar: theme.mixins.toolbar,
});

const statuses = [
  'new',
  'in_contact',
  'showing_booked',
  'applying',
  'converted',
  'waitlisted',
  'rejected',
];

const qualities = ['Hot', 'Warm', 'Cold', ''];

export default withStyles(styles)(
  withMobileDialog()(
    connect(
      store => ({
        prospects: store.prospects.prospects,
        prospect: store.prospects.prospect,
        trafficSources: store.landlordLeads.trafficSources,
        fetchingProspects: store.prospects.fetchingProspects,
        prospectsCounts: store.prospects.prospectsCounts,
        properties: store.landlordProperties.properties,
        unitTypes: deepDiver(store, 'companyDetails.companyPreferences.unit_types') || [],
      }),
      {
        ...prospectsActions,
        getProperties,
        getLandlordTrafficSources,
        submit,
      }
    )(
      localize()(
        class LandlordProspects extends Component {
          constructor(props) {
            super(props);
            this.state = {
              addProspectDrawerOpen: false,
              filtersActive: false,
              filters: {
                search: '',
                properties: Array(this.props.properties.length).fill(false),
                statuses: Array(statuses.length).fill(false),
                qualities: Array(qualities.length).fill(false),
              },
              drawerVisible: false,
              currentTab: 'new',
              sortKey: '',
              sortOrder: '',
              offset: 0,
            };
          }

          setRef = ref => (this.table = ref);

          fetchProspectsAndStats = () => {
            this.props.getProspectStats();
            this.fetchProspects();
          };

          componentDidMount = () => {
            this.fetchProspectsAndStats();
            this.props.getLandlordTrafficSources();
            this.props.getProperties({ for_multiselect: true });
          };

          filterProperties = booleanArrayMask => {
            return this.props.properties.filter((_, i) => booleanArrayMask[i]);
          };

          filterStatuses = booleanArrayMask => {
            return statuses.filter((_, i) => booleanArrayMask[i]);
          };

          filterQualities = booleanArrayMask => {
            return qualities.filter((_, i) => booleanArrayMask[i]);
          };

          toggleAddProspectDrawer = () => {
            if (this.state.addProspectDrawerOpen) {
              this.setState(
                {
                  offset: 0,
                },
                () => {
                  this.fetchProspectsAndStats();
                }
              );
            }

            this.setState(prevState => ({
              addProspectDrawerOpen: !prevState.addProspectDrawerOpen,
            }));
          };

          getTableDataAndResetOffset = () => {
            this.setState(
              {
                offset: 0,
              },
              () => this.fetchProspectsAndStats()
            );
            if (this.table) this.table.scrollToTop(0);
          };

          fetchProspectAndTableData = async () => {
            await this.props.getProspectDetails(this.props.prospect.id);
            this.getTableDataAndResetOffset();
          };

          toggleProspectDetailsDialog = async () => {
            if (this.state.prospectDetailsDialog) {
              await this.props.displayProspect({});
              this.getTableDataAndResetOffset();
            }

            this.setState(prevState => ({
              prospectDetailsDialog: !prevState.prospectDetailsDialog,
            }));
          };

          handleClearSearch = setFieldValue => {
            this.setState(
              {
                filtersActive: false,
                filters: {
                  search: '',
                  properties: Array(this.props.properties.length).fill(false),
                  statuses: Array(statuses.length).fill(false),
                  qualities: Array(qualities.length).fill(false),
                },
                offset: 0,
              },
              () => this.fetchProspects()
            );

            if (this.table) this.table.scrollToTop(0);
            setFieldValue('search', '');
            setFieldValue('properties', Array(this.props.properties.length).fill(false));
            setFieldValue('statuses', Array(statuses.length).fill(false));
            setFieldValue('qualities', Array(qualities.length).fill(false));
          };

          handleFilters = values => {
            const isFiltersUntouched =
              values.search === '' &&
              !values.properties.includes(true) &&
              !values.statuses.includes(true) &&
              !values.qualities.includes(true);
            const newState = {
              filtersActive: !isFiltersUntouched,
              filters: {
                search: values.search,
                properties: values.properties,
                statuses: values.statuses,
                qualities: values.qualities,
              },
              drawerVisible: false,
              offset: 0,
            };

            if (this.table) this.table.scrollToTop(0);
            this.setState(newState, () => this.fetchProspects());
          };

          columns = [
            {
              title: 'Status',
              dataKey: 'status_verbiage',
              sortable: false,
              width: 150,
              render: ({ data }) => <StatusTag status={data} />,
            },
            {
              title: 'Quality',
              dataKey: 'temperature',
              sortable: true,
              width: 150,
              render: ({ data }) => (
                <StyledQualitySpan temperature={data}>{data}</StyledQualitySpan>
              ),
            },
            {
              title: 'Full Name',
              dataKey: 'full_name',
              sortable: true,
              width: 400,
            },
            {
              title: 'Phone Number',
              dataKey: 'phone_number',
              sortable: false,
              width: 250,
              render: ({ data }) => formatPhone(data),
            },
            {
              title: 'Email',
              dataKey: 'email',
              sortable: true,
              width: 300,
            },
            {
              title: 'Age',
              dataKey: 'created_at',
              sortable: true,
              width: 200,
              render: ({ data }) => timeFromNow(data),
            },
            {
              title: 'Traffic Source',
              dataKey: 'source',
              sortable: false,
              width: 250,
            },
            {
              title: 'Desired Move-in',
              dataKey: 'move_in_date',
              sortable: true,
              width: 200,
            },
            {
              title: 'Desired Unit',
              dataKey: 'desired_unit_type',
              sortable: false,
              width: 250,
            },
            {
              title: 'Last Contacted',
              dataKey: 'last_contacted_at',
              sortable: true,
              width: 200,
            },
          ];

          handleSort = (key, order) => {
            this.setState(
              {
                sortKey: key,
                sortOrder: order,
                offset: 0,
              },
              () => {
                this.fetchProspects();
              }
            );
            if (this.table) this.table.scrollToTop(0);
          };

          handleTabChange = tabName => {
            this.setState(
              {
                currentTab: tabName,
                offset: 0,
              },
              () => {
                this.fetchProspects();
              }
            );
            if (this.table) this.table.scrollToTop(0);
          };

          toggleDrawer = async tenantID => {
            await this.props.getProspectDetails(tenantID);
            this.toggleProspectDetailsDialog();
          };

          fetchProspects = () => {
            const { currentTab, filters, filtersActive, offset, sortKey, sortOrder } = this.state;

            let fetchPromise = null;
            let filterOptions = {
              sort_key: sortKey,
              sort_order: sortOrder,
            };

            let subset = currentTab;

            if (filtersActive) {
              const propertiesToFilter = this.filterProperties(filters.properties).map(
                data => data.value
              );
              const statusesToFilter = this.filterStatuses(filters.statuses);
              const qualitiesToFilter = this.filterQualities(filters.qualities);
              filterOptions = {
                query: filters.search,
                property_ids: propertiesToFilter,
                statuses: statusesToFilter,
                qualities: qualitiesToFilter,
                sort_key: sortKey,
                sort_order: sortOrder,
              };

              subset = 'all';
            }

            fetchPromise = this.props.getFilteredProspects(subset, offset, filterOptions);

            fetchPromise.then(() => {
              this.setState({
                offset: this.props.prospects.length,
              });
            });
          };

          accentColor = AccentColor();

          render() {
            const { filters } = this.state;
            const { prospects, prospectsCounts } = this.props;

            const filterOptions = [
              {
                useSearch: true,
                options: this.props.properties.map(data => data.label),
                name: 'properties',
                title: 'Select properties to filter by',
              },
              {
                useSearch: false,
                options: statuses,
                name: 'statuses',
                title: 'Filter by prospect status',
              },
              {
                useSearch: false,
                options: qualities,
                name: 'qualities',
                title: 'Filter by prospect quality',
              },
            ];

            const tabs = [
              {
                title: 'New',
                label: 'New',
                value: 'new',
                count: prospectsCounts['new'] || 0,
                onClick: () => this.handleTabChange('new'),
              },
              {
                title: 'Working',
                label: 'Working',
                value: 'working',
                count: prospectsCounts['working'] || 0,
                onClick: () => this.handleTabChange('working'),
              },
              {
                title: 'Wait Listed',
                label: 'Wait Listed',
                value: 'waitlisted',
                count: prospectsCounts['waitlisted'] || 0,
                onClick: () => this.handleTabChange('waitlisted'),
              },
              {
                title: 'Stale',
                label: 'Stale',
                value: 'stale',
                count: prospectsCounts['stale'] || 0,
                onClick: () => this.handleTabChange('stale'),
              },
              {
                title: 'Rejected',
                label: 'Rejected',
                value: 'rejected',
                count: prospectsCounts['rejected'] || 0,
                onClick: () => this.handleTabChange('rejected'),
              },
              {
                title: 'Converted',
                label: 'Converted',
                value: 'converted',
                count: prospectsCounts['converted'] || 0,
                onClick: () => this.handleTabChange('converted'),
              },
              {
                title: 'All',
                label: 'All',
                value: 'all',
                count: prospectsCounts['all'] || 0,
                onClick: () => this.handleTabChange('all'),
              },
            ];

            const filteredData = prospects.map(datum => {
              if (datum.phone_number) {
                return {
                  ...datum,
                  phone_number: formatPhone(datum.phone_number),
                };
              } else {
                return datum;
              }
            });

            return (
              <StyledMain>
                <StyledHeaderContainer>
                  <StyledHeader>
                    <HeaderWithPeriod headerText={<span>Prospects</span>} newStyle />
                    <StyledAddButton
                      accentColor={this.accentColor}
                      onClick={this.toggleAddProspectDrawer}
                    >
                      Create new
                    </StyledAddButton>
                  </StyledHeader>
                  <TableFilters
                    filters={filters}
                    handleSubmitFilters={this.handleFilters}
                    handleClearFilters={this.handleClearSearch}
                    filterOptions={filterOptions}
                    accentColor={this.accentColor}
                  />
                </StyledHeaderContainer>

                <StyledTableContainer>
                  {this._renderTableView({ filteredData, tabs })}
                  {this._renderMobileView({
                    filteredData,
                    tabs,
                    currentTab: this.state.currentTab,
                    tabChange: this.handleTabChange,
                  })}
                </StyledTableContainer>

                {this._renderAddProspectDrawer()}
                {this._renderProspectDetailsDialog()}
              </StyledMain>
            );
          }

          createProspect = formData => {
            this.props
              .createProspect(formData)
              .then(() => {
                this.toggleAddProspectDialog();
                this.setState(
                  {
                    disabledAddNoticeSubmit: false,
                    offset: 0,
                  },
                  () => this.fetchProspectsAndStats()
                );
              })
              .catch
              // empty catch statement so it won't close the dialog when an error occurs
              ();
          };

          getProspect = () => {
            this.props.getProspectDetails(this.props.prospect.id);
            this.setState(
              {
                offset: 0,
              },
              () => this.fetchProspectsAndStats()
            );
          };

          _renderProspectDetailsDialog = () => (
            <Drawer
              visible={this.state.prospectDetailsDialog}
              onClose={this.toggleProspectDetailsDialog}
              closable={false}
              width={550}
            >
              <ProspectDetails
                handleClose={this.toggleProspectDetailsDialog}
                fetchProspectAndTableData={this.fetchProspectAndTableData}
                prospect={this.props.prospect}
                getProspect={this.getProspect}
                properties={this.props.properties}
                unitTypes={this.props.unitTypes}
                trafficSources={this.props.trafficSources}
                submit={this.props.submit}
              />
            </Drawer>
          );

          _renderAddProspectDrawer = () => (
            <Drawer
              visible={this.state.addProspectDrawerOpen}
              onClose={this.toggleAddProspectDrawer}
              closable={false}
              width={550}
            >
              {this.state.addProspectDrawerOpen && (
                <CreateProspectDrawerWizard
                  handleClose={this.toggleAddProspectDrawer}
                  properties={this.props.properties}
                  unitTypes={this.props.unitTypes}
                  trafficSources={this.props.trafficSources}
                />
              )}
            </Drawer>
          );

          _renderProspectDrawer = () => (
            <MuiThemeProvider theme={createMuiTheme(drawerStyle)}>
              <Drawer
                open={this.state.showMaintenanceDrawer}
                onClose={this.toggleMaintenanceDrawer}
                anchor="right"
              />
            </MuiThemeProvider>
          );

          _renderTableView = ({ filteredData, tabs }) => {
            let groupBy = 'property_name';
            if (featureEnabled('ui.properties.namespace_by_city')) {
              groupBy = 'property_name_city';
            }
            return (
              <MediaQuery query="(min-device-width: 750px)">
                <TabbedTable
                  setRef={this.setRef}
                  groupRowsBy={groupBy}
                  tabs={tabs}
                  columns={this.columns}
                  data={filteredData}
                  loadMoreData={this.fetchProspects}
                  isLoading={this.props.fetchingProspects}
                  filtersActive={this.state.filtersActive}
                  onColumnClick={data => {
                    this.handleSort(data.key, data.order);
                  }}
                  onRowClick={data => {
                    this.toggleDrawer(data.original_id);
                  }}
                />
              </MediaQuery>
            );
          };

          _renderMobileView = ({ filteredData, tabs, currentTab, tabChange }) => {
            let groupBy = 'property_name';
            if (featureEnabled('ui.properties.namespace_by_city')) {
              groupBy = 'property_name_city';
            }
            return (
              <MediaQuery query="(max-device-width: 750px)">
                <MobileTable
                  groupRowsBy={groupBy}
                  data={filteredData}
                  tabs={tabs}
                  tabIndex={currentTab}
                  tabChange={tabChange}
                  filtersActive={this.state.filtersActive}
                  columns={this.columns}
                  title="full_name"
                  tag="status_verbiage"
                  stickyHeaderTop={this.state.filters.search ? '137px' : '107px'}
                  fieldsAboveFold={[
                    {
                      title: 'Phone Number',
                      key: 'phone_number',
                    },
                  ]}
                  fieldsBelowFold={[
                    {
                      title: 'Email',
                      key: 'email',
                    },
                    {
                      title: 'Move in Date',
                      key: 'move_in_date',
                    },
                    {
                      title: 'Desired unit',
                      key: 'desired_unit_type',
                    },
                  ]}
                  onRowClick={data => {
                    this.toggleDrawer(data.id);
                  }}
                />
              </MediaQuery>
            );
          };
        }
      )
    )
  )
);
